import { get } from './client'
import type { SystemStatus, UptimeGroup } from '@/types'

/**
 * 获取系统状态（首屏调用）
 * GET /api/status
 */
export async function getSystemStatusApi(): Promise<SystemStatus> {
  return get<SystemStatus>('/api/status')
}

/**
 * 获取站点公告
 * GET /api/notice
 */
export async function getNoticeApi(): Promise<string> {
  return get<string>('/api/notice')
}

/**
 * 获取 Uptime 监控数据
 * GET /api/uptime/status
 */
export async function getUptimeStatusApi(): Promise<UptimeGroup[]> {
  return get<UptimeGroup[]>('/api/uptime/status')
}

/**
 * 获取模型广场可用模型（公开）
 * GET /api/models
 */
export async function getPublicModelsApi(): Promise<string[]> {
  return get<string[]>('/api/models')
}
